const isLoading = false;
const agents = [];
const clients = [];
const requestArrayInputStatus = []
const requestArrayOutputStatus = []
const inputTransactions = [];
const outputTransactions = [];
const responseInputFilter = [];
const responseOutputFilter = [];
const superArrayInputTransactions = [];
const superArrayOutputTransactions = [];
const input_transaction = {
    products: [{
        item: {
            product: {}, uuid: "", product_name: "", type: "", price: 0.00, discount: 0.00, final_price: 0.00, isPercentage: false, 
            observation: "", category: "", subcategory: "",
        },
        booking: {
            product_place: "", observation: "", date: "", time: "", people: "",
            hash: "", created_date: "", channel: "", booking_code: "", status: "",
            items: [],
            product: { id: "", uuid: "", place_uuid: "" },
            payments: [],
            term: { hash: "", confirm: false, datetime: "" },
        },
        readonly: false, removed: false,
    }],
    payments: [{
        payment_method: {index:null, name: ""}, value: 0.00, date: "", cv: "", aut:"", pix_id:"", invoice_number: "", customer_name: "", customer_document: "",
        card_flag: {id:null, label: ''}, installments: 1, readonly: false, removed: false, open: true,
    }],
    general: { id: null, user: { uuid: "", name: "", }, date: "", label: "", open: true, bill_final_value: 0.00, bill_total_value: 0.00, bill_total_discount: 0.00, bill_status: "", },
    type: "1",
};

const output_transaction = {
    payment: {
        payment_method: { index:null, name: "" }, value: 0.00, date: "", cv: "", aut:"", pix_id:"", invoice_number: "", supplier_name: "", supplier_document: "",
    },
    general: { id: null, user: { uuid: "", name: "", }, date: "", label: "", observation: "", },
    type: "0",
}

const financeReportData = []

export default {
    agents,
    clients,
    isLoading,
    input_transaction,
    output_transaction,
    requestArrayInputStatus,
    requestArrayOutputStatus,
    inputTransactions,
    outputTransactions,
    responseInputFilter,
    responseOutputFilter,
    superArrayInputTransactions,
    superArrayOutputTransactions,
    financeReportData,
}